import React, { memo, useEffect, useState } from 'react';
import { Grid, Box, Typography, useTheme } from '@mui/material';
import Acordeon from './Acordeon/Acordeon';
import { convertToCamelCase } from '@shared/helpers';
import ClusterPlaneIconColor from '@shared/assets/ClusterPlaneIconColor';

import FlightSummary from './FlightSummary';
import { sxStyled } from './styles';
import { hasManyOptions } from '../helpers';

const Cluster = memo(
  ({
    element,
    infoFlightsSearch,
    index,
    flightsInUSD,
    canBuy,
    canBook,
    handleOpenDrawer,
    CanSaleInUsd,
    validateBaggage,
    businessTypes,
    passengers,
    isDrawer,
  }) => {
    const theme = useTheme();
    const sxStyle = sxStyled(theme);

    const [activeRadio, setActiveRadio] = useState([]);
    const [seeShareItineraryModal, setSeeShareItineraryModal] = useState(false);

    useEffect(() => {
      const shortestFlightOptions = element.legs.map(leg =>
        leg.options.reduce((shortest, option) =>
          option.flight_time < shortest.flight_time ? option : shortest
        )
      );
      setActiveRadio(shortestFlightOptions);
    }, [element]);

    const handleRadio = (index, object_option) => {
      setActiveRadio(prevState => {
        const newState = [...prevState];
        newState[index] = object_option;
        return newState;
      });
    };

    const setOpenSeeShareItineraryModal = () => {
      setSeeShareItineraryModal(true);
    };

    const legsSelect = element.legs.map((leg, index) => {
      return { ...leg, options: [activeRadio[index]] };
    });

    const legsSelectUnit = element.legs.map((leg, index) => {
      return { ...leg, ...activeRadio[index] };
    });

    const body = {
      id_integration: 2,
      operation_id: element.operation_id,
      options_ids: activeRadio.map(data => data.id_option),
      cluster: {
        ...element.cluster,
        legs: legsSelect,
      },
    };

    return (
      <Grid
        container
        id={`airline-cluster-${element.cluster_id}`}
        key={`cluster-${index}`}
        sx={{
          borderRadius: '10px',
          width: 'auto',
          height: 'auto',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: '#fff',
          mb: { xs: '20px', lg: '30px' },
          mx: { xs: '20px', lg: 0 },
          border: { xs: '2px solid #E5E5E5', lg: 'none' },
        }}
        className="airline-cluster"
      >
        <Box sx={sxStyle.cardContent}>
          <Grid
            container
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'space-evenly',
            }}
          >
            <Grid item xs={12} md={8} sx={{ height: 'auto', mb: '13px' }}>
              {element.legs.map((elementLeg, indexLeg) => (
                <React.Fragment key={`${elementLeg.title}-${indexLeg}`}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      gap: 2,
                      my: '4vh',
                      mx: 2,
                    }}
                  >
                    <Box
                      sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
                    >
                      <ClusterPlaneIconColor
                        id="cluster-plane-icon"
                        color={theme.tertiary}
                        rotate={indexLeg === 1 ? 180 : 0}
                      />

                      <Typography
                        sx={{
                          ...sxStyle.clusterTitles,
                          borderRight: { xs: 'none', sm: '1px solid #d3d3d3' },
                          paddingRight: { xs: 0, sm: 1 },
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <Box component="span" sx={sxStyle.titleType}>
                          {elementLeg?.title}
                        </Box>
                        {elementLeg?.short_date}
                      </Typography>
                    </Box>

                    <Typography sx={sxStyle.clusterTitles}>
                      {convertToCamelCase(elementLeg.origin_destination)}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 2,
                      width: '100%',
                    }}
                  >
                    {(() => {
                      const hasManyOptionsInLeg = hasManyOptions(
                        elementLeg.options
                      );

                      let optionsToRender;

                      if (isDrawer) {
                        optionsToRender = elementLeg.options;
                      } else if (hasManyOptionsInLeg) {
                        optionsToRender = [
                          activeRadio[indexLeg] || elementLeg.options[0],
                        ];
                      } else {
                        optionsToRender = elementLeg.options;
                      }

                      return optionsToRender.map((option, index) => (
                        <Acordeon
                          key={option.hash}
                          element={element}
                          index={index}
                          object_option={option}
                          title={elementLeg.title}
                          indexLeg={indexLeg}
                          activeRadio={
                            activeRadio[indexLeg]?.hash == option.hash
                          }
                          handleRadio={handleRadio}
                        />
                      ));
                    })()}
                  </Box>
                </React.Fragment>
              ))}
            </Grid>

            <Grid sx={sxStyle.hideOnMobile}>
              <Box sx={sxStyle.separatorVertical}></Box>
            </Grid>

            <Grid item xs={10} md={3} sx={{ height: 'auto' }}>
              <FlightSummary
                element={element}
                flightsInUSD={flightsInUSD}
                infoFlightsSearch={infoFlightsSearch}
                activeRadio={activeRadio}
                passengers={passengers}
                canBuy={canBuy}
                canBook={canBook}
                body={body}
                legsSelectUnit={legsSelectUnit}
                businessTypes={businessTypes}
                setOpenSeeShareItineraryModal={setOpenSeeShareItineraryModal}
                seeShareItineraryModal={seeShareItineraryModal}
                setSeeShareItineraryModal={setSeeShareItineraryModal}
                handleOpenDrawer={handleOpenDrawer}
                CanSaleInUsd={CanSaleInUsd}
                validateBaggage={validateBaggage}
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>
    );
  }
);

export default Cluster;
